import React from 'react';
import Form from "./components/form"
import './App.css';

const App=()=> {
  return (
    <div >
      <h1>Currency Converter</h1>
      <Form/>
    </div>
  );
}

export default App;
